import Vue from 'vue'
import { on } from 'dom-event'
import select from 'select-dom'

export default el => new Vue({
  name: 'Split Scroller',
  el,
  data() {
    return {
      isMobile: false,
    }
  },
  mounted() {
    this.$nextTick(() => {
      this.destroyCarouselOnDesktop()
      on(window, 'resize', this.destroyCarouselOnDesktop)
      on(window, 'orientationchange', this.destroyCarouselOnDesktop)
    })
  },
  methods: {
    destroyCarouselOnDesktop() {
      this.isMobile = window.innerWidth < 768
      const carousel = select('.swiper', this.$refs.splitScrollerRight)
      if (!this.isMobile && carousel.swiper) {
        carousel.swiper.destroy()
      }
    }
  }
})